import Cookies from 'js-cookie';

import getForcedBucket from '../utils/getForcedBucket';

const getWikiaBucketId = () => {
	return Cookies.get('exp_bucket') || '';
};

/**
 * Gets the current bucket for user based on the following rules:
 *
 * - If the user is in a forced bucket, return that bucket.
 * - If the user is not in a forced bucket, return the bucket based on `getWikiaBucketId`.
 */
export function getCurrentBucket(): string {
	const forcedBucket = getForcedBucket();

	if (typeof forcedBucket !== 'undefined' && forcedBucket?.length > 0) {
		return forcedBucket;
	}

	return getWikiaBucketId() || '100';
}
